import { IMediaAndContent } from "./MediaAndContent"

// ---> BASE INTERFACES <--- //
export interface IIndicator {
    breadcrumbs: string;
    titulo: string;
    state: number | null
    evaluaciones?: Evaluaciones;
    descripcion: string;
    notas: string;
    fuente: string | null;
    graphics: Graphics[];
    id?: number;
    variable_indicador?: Variable_indicator[];
    data?: AllData[];
    documento_informativo: string;
    investigaciones: IMediaAndContent[];
    ods: ODSPriorityGroups[];
    grupos_prioritarios: ODSPriorityGroups[];
    searchMatchInfo?: SearchMatchInfo;
    dimension: { id: number; titulo: string };
    subdimension: { id: number; titulo: string };
    //Capa del mapa
    capa_mapa?: CapaMapa[]
}

export interface Law {
    id: number;
    titulo: string;
    descripcion: string;
    derecho: string;
    dimension: DimensionLaw;
    subdimensiones: SubdimensionLaw[];
    subdimension: SubdimensionLaw;
    tipo: string;
    fecha: string;
    pdf: string;
    url: string | null;
    breadcrumbs: string;
    ods?: ODSPriorityGroups[];
    grupos_prioritarios?: ODSPriorityGroups[];
    evaluaciones?: EvaluacionesLaw;
    state: string | null;
    searchMatchInfo?: SearchMatchInfo;
}

export interface Graphics {
    id: number;
    titulo: string;
    graph_name: string;
    type_of_graph: 1 | 2 | 3 | 4 | 5 | 6 | 7;
    tipo_mapa?: "Base" | "Calor"; // Agregado para mapas
    maps?: BaseMap[]; // Datos específicos de mapas
    nota_grafico?: string;
    documento_informativo?: string;
    variable_analisis?: string[];
    porcentual?: null | 1 | 0;
    maximo?: number | null;
    minimo?: number | null;
    intervalo?: number | null;
    ticks?: number[];
    filtros: Filtro[];
    escala?: 0 | 1 | null;
    eje_y2?: boolean;
    eje_y2_data?: AxisYRight;
    data_formated?: ChartData[] | any[];
    tooltip_indicadores_proc?: string[];
    additionalInfo: Record<string, number | string>[]; //Información adicional mapas de calor
    dynamicInfo?: Record<string, string>[]; //Información dinámica por comuna+filtros (encabezado/anio/valor) mapas de calor
    //vertical 0 || horizontal 1
    orientation?: 0 | 1 | null;
}

interface AxisYRight {
    minimo: null | number;
    maximo: null | number;
    intervalo: null | number;
    type_of_graph: null | number;
    variable_analisis: Variable_indicator[] | null;
    ticks: number[];
}

interface Evaluaciones {
    [year: string]: "1" | "0" | "-1" | null; // Estados representados por valores trivalentes
}

interface EvaluacionesLaw {
    [year: string]: "Cumple" | "Restringe" | "No Aplica" | null;
}
// ---> MAP SPECIFIC INTERFACE <--- //
export interface BaseMap {
    coordenadas?: [number, number]; // Para mapas Base
    "Tipo establecimiento"?: string;
    "Nombre unidad"?: string;
    "Comuna para mapa"?: string;
    "anio": string;
    comuna?: string; // Para mapas tipo Calor
    valor?: string;  // Para mapas tipo Calor
}

export interface AllData {
    anio: string,
    encabezado: string,
    indicador_id?: null | string,
    valor: string
}

export interface Variable_indicator {
    id: number,
    titulo: string,
    values: string[]
}

//interface Variables Indicator REDUX
export interface VariablesIndicator {
    id: number,
    titulo: string,
    values: ValuesOption[]
}

interface ValuesOption {
    value: string,
    id: number | string,
    orden?: number,
    color?: string,
}

export interface Filtro {
    orden?: number;
    eje1?: 0 | 1 | null;
    eje2?: 0 | 1 | null;
    id?: number;
    name: string;
    values: ValuesOption[]
}

export interface PieChartData {
    name?: string;
    value?: number;
    fill?: string;
}

export interface BarCharts {
    [key: string]: number | string | undefined;
}

export interface GraphicsDomain {
    maximo: number | null;
    minimo: number | null;
    intervalo: number | null;
    ticks: number[];
}

export interface ChartData {
    // Common properties for both types
    name: string;
    value?: number;
    fill?: string;
    percent?: number;
    maximo: number;
    minimo: number;
    intervalo: number;
    // Propiedades adicionales de tipo numérico
    [key: string]: number | string | undefined;
}

export interface ODSPriorityGroups {
    id: number,
    nombre: string,
    description: string,
    color: string,
    pdf: string,
    numero: string
}

export type IndicatorOrLaw =
    | (IIndicator & { type: 'indicator' })
    | (Law & { type: 'law' });

export function isIndicator(item: any): item is IIndicator {
    return (
        item &&
        typeof item === 'object' &&
        'tipo_indicador' in item &&
        (item.tipo_indicador === 'Proceso' || item.tipo_indicador === 'Resultados')
    );
}

interface SubdimensionLaw {
    nombre: string,
    valoración: string | null,
    id: number,
}

interface DimensionLaw {
    nombre: string;
    id: number;
}

export interface ChartsProps {
    data: BarCharts[];
    typeOfIndicador: string;
    variable_analisis: string[];
    range?: GraphicsDomain | null;
    errorsNoData: boolean;
    filters: Filtro[];
    tooltip_indicadores_proc?: string[];
    //vertical 0 || horizontal 1
    orientation?: 0 | 1 | null;
}

export interface SearchInformation {
    originalSearch: string;
    synonymsUsed: string[];
    activeSynonyms: string[];
}

export interface SearchMatchInfo {
    matchedWithOriginal: boolean,
    matchedSynonyms: string[],
    matchType: "original" | "both" | "synonym"
}

//capas del mapa
export interface ListadoItem {
    id: number;
    nombre: string;
    coordenadas: string;
    fecha_alta: string;
    fecha_baja: string | null;
    estado: number;
}

export interface CapaMapa {
    id: number;
    nombre: string;
    imagen: string;
    estado: number;
    items: ListadoItem[];
}